export const theme = {
  main: {
    typography: {
      tsh3: {
        fontFamily: "Poppins",
        fontSize: "46px",
        fontWeight: "600",
        lineHeight: "75.16px",
        textAlign: "center",
        textUnderlinePosition: "from-font",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsh4: {
        fontFamily: "Poppins",
        fontSize: "33px",
        fontWeight: "500",
        lineHeight: "44.02px",
        textAlign: "center",
        textUnderlinePosition: "from-font",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsh5: {
        fontFamily: "Poppins",
        fontSize: "46px",
        fontWeight: "300",
        lineHeight: "75.16px",
        textAlign: "center",
        textUnderlinePosition: "fromFont",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsb4: {
        fontFamily: "Poppins",
        fontSize: "24px",
        fontWeight: "300",
        lineHeight: "32.02px",
        textAlign: "left",
        textUnderlinePosition: "fromFont",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsb2: {
        fontFamily: "Poppins",
        fontSize: "25px",
        fontWeight: "500",
        lineHeight: "33.35px",
        textAlign: "center",
        textUnderlinePosition: "fromFont",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsb1: {
        fontFamily: "Poppins",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        textAlign: "center",
        textUnderlinePosition: "fromFont",
        textDecorationSkipInk: "none",
        color: "#000000",
      },
      tsb3: {
        fontFamily: "Poppins",
        fontSize: "13px",
        fontWeight: 300,
        lineHeight: "17.34px",
        textAlign: "center",
        textUnderlinePosition: "from-font",
        textDecorationSkipInk: "none",
        color: "#FFFFFF",
      },
      tsb5: {
        color: "#000000",
        fontFamily: "Montserrat",
        fontSize: "16.53px",
        fontWeight: 500,
        lineHeight: "24.8px",
        textAlign: "right",
        textUnderlinePosition: "from-font",
        textSecorationSkipInk: "none",
      },
    },
  },
  light: {
    typography: {
      allVariants: {
        color: "#000000",
      },
    },
  },
};
